const messages = {
  'Business.business': 'BUSINESS CONTENTS',

  'TopMenu.home': 'HOME',
  'TopMenu.company': 'COMPANY',
  'TopMenu.history': 'HISTORY',
  'TopMenu.salesItems': 'SALES ITEMS',
  'TopMenu.contact': 'CONTACT',

  'Hero.title': 'HANSUK',
  'Hero.subtitle': 'HANSUK INTERNATIONAL LTD.',

  'Story.title': 'Extraordinary Makes Ordinary\n\nWe make everyday stuff\nWe make your day\nWe are made in Hansuk.',

  'Story2.title': '특별함이, 매일의 평범함을 창조합니다.\n\n편안하고 멋진 신발. 친환경적인 타이어.\n휴대전화와 컴퓨터의 핵심소재.\n열이나 압력과 같은 에너지.\n \n이런것들을 통해\n우리는 사람들의 일상이 됩니다.\n우리는 한석입니다.',

  'Company.title': 'WELCOME TO HANSUK INTERNATIONAL',
  'Company.description': '당사는 1975년 일본의 전문 상사인 白石칼슘(株)(Shiraishi Calcium Kaisha Ltd.)와 공동으로 설립한 현지법인이며 주로 한일간의 무역을 통하여 국내산업 발전에 기여함은 물론 미래의 방향 예측과 설정에 필요한 정보를 제공하는 등 다양하고 순발력 있는 Service를 기본이념으로 하고 있는 전문 상사입니다.\n\n창사 이래 산업의 다양한 변천과정에서도 변함없이 최선을 다하여 고객의 여망에 부흥해 왔으며 앞으로도 일관되게 정성스럽고도 순발력 있는 자세로 고객의 발전에 이바지 하고자 합니다. 무역상사로서의 전통적인 수출입업에 국한하지 않고, 수 십 년간 쌓아 온 다양하고 해박한 산업정보와 일본, 중국, 동남 아시아에 구축한 탄탄하고 폭 넓은 네트워크를 활용하여 고객이 원하는 최상의 서비스를 제공 해 드리도록 약속 하겠습니다. 고객 여러분의 아낌없는 성원과 사랑을 부탁 드립니다.\n\n<strong>대표이사 사장</strong> 전 정 욱',
  'Company.profileTitle': 'COMPANY PROFILE',
  'Company.profileDescription': '회사명 : 한석인터내셔날(주)\n주소 : 서울특별시 중구 세종대로73 태평로빌딩 9층\n창립일 : 1975년 4월 21일\nTel. : 02-756-1181~4',
  'Company.profileDescriptionEnglish': 'CORPORATE NAME : Hansuk International Ltd.\nADDRESS : 9F., taepyeong-ro building, 73, Sejong-daero, <span>Jung-gu, Seoul, 04514, Korea </span>TEL. : +82-2-756-1181~4',
  'Company.businessTitle': 'BUSINESS CONTENTS',
  'Company.viewBusiness': '자세히 보기',

  'History.title': 'HANSUK HISTORY',
  'History.1975_date': '1975년 4월 21일',
  'History.1975_description': '韓石인터내셔날(주)설립 日本 SHIRAISHI CALCIUM KAISHA, LTD.와 공동투자법인\n日本 KOBE STEEL, LTD. 산업기계부분 대리점 계약 체결\n日本 中田 ENGINEERING CO., LTD. 대리점 계약 체결',
  'History.1976_date': '1976년',
  'History.1976_description': '日本 AJINOMOTO CO., INC.사의 DN-TP 이형지 부분 대리점 계약 체결',
  'History.1982_date': '1982년',
  'History.1982_description': '日本 MEC COMPANY LTD.사와 대리점 계약 체결',
  'History.1997_date': '1997년',
  'History.1997_description': '日本 AJINOMOTO FINE-TECHNO CO., INC.사와 전자재료 부분 대리점 계약 체결',
  'History.2000_date': '2000년',
  'History.2000_description': '日本 NODA SCREEN CO., LTD.사와 대리점 계약 체결',
  'History.2013_date': '2013년',
  'History.2013_description': 'KOBE STEEL COMPRESSOR용 LUBE OIL SYSTEM UNIT PACKAGE 제조 공장 (KALA) 합작 설립\n(KOBE STEEL ASIA LUBE OIL SYSTEM ASIA)',

  'SalesItems.chemicalTitle': 'CHEMICAL',
  'SalesItems.machineryTitle': 'MACHINERY',
  'SalesItems.Manufacturer': 'Manufacturer',
  'SalesItems.chemicalName': 'Chemical Name',
  'SalesItems.materialName': 'Material Name',
  'SalesItems.division': 'Division',
  'SalesItems.machine': 'Machine',

  'Contact.title': '문의사항',

  'ContactForm.email': '이메일',
  'ContactForm.name': '이름',
  'ContactForm.title': '제목',
  'ContactForm.message': '메시지',
  'ContactForm.hasError': '{inputs} 항목을 재확인 후 보내기를 눌러주세요.',
  'ContactForm.invalidEmailError': '잘못된 이메일 주소입니다.',
  'ContactForm.messageSent': '{email} 주소로 확인 메일을 보냈습니다. 문의 감사합니다.',
  'ContactForm.requiredError': '필수 항목 입니다.',
  'ContactForm.send': '보내기',
  'ContactForm.serviceError': '죄송합니다. 서버 문제로 문의 보내기를 실패했습니다. 잠시 후 다시 시도해주세요.',
  'ContactForm.tryNewMessage': '새로운 문의하기',

  'Footer.hansuk': '- 주식회사 한석인터내셔날 -',
  'Footer.top': 'TOP',
  'Footer.copyright': 'COPYRIGHT © Hansuk international LTD, All rights reserved.',
  'Footer.navylab': 'Designed by Navylab',

  'NotFound.title': 'Not Found',
  'NotFound.description': '요청하신 페이지를 찾을 수 없습니다.',
  'NotFound.action': '홈으로 가기',
};

export default messages;



// WEBPACK FOOTER //
// ./src/i18n/ko.js